<template>
  <NuxtLayout>
    <section class="accommodationFacility__Header">
      <div class="container">
        <div class="accommodationFacility__HeaderTop">
          <div class="accommodationFacility__LocationInfo">
            <div class="accommodationFacility__Place">
              <Icon name="location" />
              {{ activeAccommodation.place.name }}
            </div>
            <h2 v-text="activeAccommodation.name" />
            <div class="accommodationFacility__Stars">
              <Icon v-for="i in activeAccommodation.category_rating" name="star" />
            </div>
          </div>

          <div class="accommodationFacility__CheckRates">
            <Button
              v-if="availableDates && Object.keys(availableDates).length"
              :to="{ path: link('AccommodationUnitList'), query: { accommodation_id: page.accommodation.id } }"
              type="nuxt-link"
              negative
              prevent
              @click.native.prevent="handleRoomsListingClick($event, { path: link('AccommodationUnitList'), query: { accommodation_id: page.accommodation.id } })"
            >
              {{ $t('checkRates') }}
            </Button>
          </div>
        </div>
        
        <div class="accommodationFacility__HeaderBottom">
          <Button class="accommodationFacility__HotelOverview" type="nuxt-link" :to="activeAccommodation.sef" secondary medium>
            <template #prepend><Icon name="arrow-left" /></template>
            {{ $t('hotelOverview') }}
          </Button>

          <ul v-if="page.other_facilities?.length" class="accommodationFacility__OtherFacilities">
            <li v-for="item in page.other_facilities">
              <nuxt-link :to="item.sef">{{ item.title }}</nuxt-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
    
    <section class="accommodationFacility__Intro container">
      <h1 v-text="page.title" />
      <p v-text="page.description" />
    </section>

    <CMSField v-if="page?.content" :data="page.content" />
  </NuxtLayout>
</template>

<script setup>
  const props = defineProps({
    page: {}
  })
  const { accommodationsData, link } = useSetup();
  const { getAvailabilityDates, updateSearchDates } = useAvailabilityDates();
  const availableDates = ref(null);

  const activeAccommodation = computed(() => {
    const accommodation = accommodationsData.value[props.page.accommodation.id]
    availableDates.value = getAvailabilityDates(accommodation.availability_calendar);
    return accommodation;
  });

  async function handleRoomsListingClick(event, link) {
    await updateSearchDates(availableDates.value, true);
    await navigateTo(link);
  }

  onMounted(() => {
    getThemeStyles(activeAccommodation.value);
  })

  onBeforeUnmount(() => {
    removeThemeStyles();
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_accommodationFacility.scss');
</style>